<div class="row">
  <div class="col-md-6 p-0">
    <app-grid
      [columns]="columns"
      [rows]="data.tableRows"
      [tableParams]="data.tableParams"
      [multiSelect]="false"
      (refreshDataFromServer)="refreshData($event)"
      (rowSelected)="emitReviewerData($event)"
      [gridName]="'examReviewerGrid'"
      [allowAdd]="false"
      [allowEdit]="false"
      [allowView]="false"
      (deleteClicked)="removeReviewer()">
    </app-grid>
  </div>

  <div class="col-md-6 p-0">
    <app-add-reviewer [selectedReviewer]="examinationReviewer"></app-add-reviewer>
  </div>
</div>